import Vue from 'vue'
import Router from 'vue-router'
import HasLayout from '@/layout/hasThor/index'
import NoThorLayout from '@/layout/noThor/index'
import Transfer from '@/transfer'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },

  {
    path: '/404',
    component: () => import('@/views/404')
  },

  {
    path: '/home',
    redirect: '/home/index',
    component: Transfer,
    name: 'Home',
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index'),
        name: 'HomeIndex',
        meta: {
          activeIndex: '0'
        }
      }
    ]
  },

  {
    path: '/recruit',
    redirect: '/recruit/index',
    component: NoThorLayout,
    name: 'Recruit',
    children: [
      {
        path: 'index',
        component: () => import('@/views/recruit/index'),
        name: 'RecruitIndex',
        meta: {
          activeIndex: '1'
        }
      }
    ]
  },

  {
    path: '/help',
    name: 'Help',
    redirect: '/help/index',
    component: NoThorLayout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/help/index'),
        name: 'HelpIndex',
        meta: {
          activeIndex: '2'
        }
      }
    ]
  },

  {
    path: '/download',
    name: 'Download',
    redirect: '/download/index',
    component: NoThorLayout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/download/index'),
        name: 'DownloadIndex',
        meta: {
          activeIndex: '3'
        }
      }
    ]
  },

  {
    path: '/consult',
    name: 'Consult',
    redirect: '/consult/index',
    component: NoThorLayout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/consult/index'),
        name: 'ConsultIndex',
        meta: {
          activeIndex: '4'
        }
      }
    ]
  },

  {
    path: '/agreement',
    name: 'Agreement',
    redirect: '/agreement/index',
    component: NoThorLayout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/agreement/index'),
        name: 'AgreementIndex'
      }
    ]
  },

  {
    path: '/node',
    component: HasLayout,
    redirect: '/node/control',
    name: 'Node',
    alwaysShow: true,
    meta: {
      title: '控制台',
      icon: 'components'
    },
    children: [
      {
        path: 'control',
        component: () => import('@/transfer'),
        name: 'Control',
        redirect: '/node/control/index',
        meta: {
          title: '节点列表',
          icon: 'components'
        },
        children: [
          {
            path: 'index',
            component: () => import('@/views/node/control/index'),
            name: 'ControlIndex',
            meta: {
              title: '首页',
              icon: 'components',
              hidden: true
            }
          },
          {
            path: 'manage',
            component: () => import('@/views/node/manage/index'),
            name: 'ControlManage',
            meta: {
              title: '节点管理',
              icon: 'components',
              hidden: true
            }
          }
        ]
      },
      {
        path: 'group',
        component: () => import('@/views/node/group/index'),
        name: 'Group',
        meta: {
          title: '分组管理',
          icon: 'components'
        }
      },
/*      {
        path: 'score',
        component: () => import('@/views/node/score/index'),
        name: 'Score',
        meta: {
          title: '奖励兑换',
          icon: 'components'
        }
      },*/
      {
        path: 'earnings',
        component: () => import('@/views/node/earnings/index'),
        name: 'Earnings',
        meta: {
          title: '查看收益',
          icon: 'components'
        }
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404' }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
